export default __webpack_public_path__ + "static/media/customisation.898af69d.jpg";